// extracted by css-extract-rspack-plugin
export default {"component":"SidebarPopupWarning-module__component___JB_1i"};